// extracted by mini-css-extract-plugin
export default {"errorModal":"errorModal_errorModal__-FaSW","content":"errorModal_content__0g7CD","isTitle":"errorModal_isTitle__1CQOi"};